module.exports = __webpack_public_path__ + "img/744.2a1e3e99.jpg";